var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51672 10.803L2.5311 11.8183C3.05852 12.3456 3.77376 12.6418 4.51954 12.6418C5.26531 12.6418 5.98055 12.3456 6.50797 11.8183L7.99954 10.3268C8.26317 10.0631 8.41127 9.70544 8.41127 9.33255C8.41127 8.95966 8.26317 8.60204 7.99954 8.33833L5.09985 5.43771C4.95824 5.29416 4.78741 5.18274 4.59895 5.11101C4.41049 5.03929 4.20881 5.00893 4.00759 5.022C3.80637 5.03507 3.61031 5.09126 3.43271 5.18677C3.25512 5.28227 3.10014 5.41485 2.97829 5.57552C-0.0601505 9.70239 1.7811 14.0496 5.51516 17.7846C9.24922 21.5196 13.5964 23.359 17.7242 20.3215C17.8849 20.1996 18.0175 20.0446 18.113 19.867C18.2085 19.6894 18.2647 19.4934 18.2777 19.2922C18.2908 19.0909 18.2605 18.8893 18.1887 18.7008C18.117 18.5123 18.0056 18.3415 17.862 18.1999L14.9614 15.2983C14.8308 15.1677 14.6758 15.064 14.5051 14.9933C14.3344 14.9225 14.1515 14.8861 13.9667 14.8861C13.782 14.8861 13.599 14.9225 13.4284 14.9933C13.2577 15.064 13.1026 15.1677 12.972 15.2983L11.4805 16.7899C11.2193 17.0511 11.012 17.3611 10.8707 17.7024C10.7293 18.0437 10.6565 18.4094 10.6565 18.7788C10.6565 19.1482 10.7293 19.5139 10.8707 19.8552C11.012 20.1965 11.2193 20.5065 11.4805 20.7677L12.5117 21.7933",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9219 2.1543H22.5469",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9219 6.37305H22.5469",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9219 10.5918H22.5469",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 2.1543H14.1094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 6.37305H14.1094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 10.5918H14.1094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogHistory);
export default __webpack_public_path__ + "static/media/call-log-history.06b738c301e030adafeeb9085d85648a.svg";
export { ForwardRef as ReactComponent };